<h1 mat-dialog-title>{{ 'CreateEmploymentHistoryRecord' | translate }}</h1>

<div [formGroup]="employmentHistoryRecordForm">
  <div class="row">
    <div class="col-12">
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>{{ 'FormerEmployer' | translate }}</mat-label>
        <input matInput formControlName="employer" placeholder="{{ 'FormerEmployerPlaceholder' | translate }}"
          [matAutocomplete]="autocompleteEmployer" />
          <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
            @for (employer of employers$ | async; track employer) {
              <mat-option [value]="employer">
                {{ employer.Name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>{{ 'FormerEmploymentAddress' | translate }}</mat-label>
          <input matInput placeholder="{{ 'FormerEmploymentAddress' | translate }}" formControlName="address" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>{{ 'EmploymentPeriod' | translate }}</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="employmentDateFrom"
              placeholder="{{ 'EmploymentDateFrom' | translate }}" />
              <input matEndDate formControlName="employmentDateTo" placeholder="{{ 'EmploymentDateTo' | translate }}" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>{{ 'EmploymentType' | translate }}</mat-label>
            <mat-select formControlName="employmentType">
              @for (employmentType of employmentTypes$ | async; track employmentType) {
                <mat-option #matOption [value]="employmentType.Id">{{
                  employmentType.Name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        @if (!isReadonly) {
          <div class="col-12">
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label>{{ 'AgreementTerminationMethod' | translate }}</mat-label>
              <mat-select formControlName="terminationOption">
                @for (agreementTerminationOption of agreementTerminationOptions$ | async; track agreementTerminationOption) {
                  <mat-option #matOption
                    [value]="agreementTerminationOption.Id" [matTooltip]="agreementTerminationOption.Name">{{
                  agreementTerminationOption.Name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        @if (isReadonly) {
          <div class="col-12">
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label>{{ 'AgreementTerminationMethod' | translate }}</mat-label>
              <input matInput placeholder="{{ 'AgreementTerminationMethod' | translate }}" formControlName="terminationOption"
                autocomplete="terminationOption" />
              </mat-form-field>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-6">
            @if (isEmploymentContract$ | async) {
              <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>{{ 'WorkingTime' | translate }}</mat-label>
                <mat-select formControlName="workingTime">
                  @for (workingTime of workingTimes$ | async; track workingTime) {
                    <mat-option #matOption [value]="workingTime.Id">{{
                    workingTime.Name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
        </div>

        @if (!isReadonly) {
          <div class="upload">
            @if ((selectedEmploymentType | async)?.IsFileRequired) {
              <alert message="AddEmploymentHistoryRecordFileInfo" alertType="info"
              ></alert>
            }
            @if (isError | async) {
              <alert message="YouHaveToAddAtLeastOneEmploymentHistoryRecordFile" [alertType]="alertType$ | async"
              ></alert>
            }
            @if (employmentHistoryRecord && employmentHistoryRecord.Files?.length > 0) {
              <div class="wrapper">
                @for (file of employmentHistoryRecord.Files; track file) {
                  <div>
                    <mat-icon>description</mat-icon>
                    {{ file }}
                    <br />
                  </div>
                }
              </div>
            }
            <fileUpload [maxFileCount]="maxFileCount"
              [alreadySavedFiles]="!!employmentHistoryRecord ? employmentHistoryRecord.Files : []"
            (onFilesChange)="onFilesChange($event)"></fileUpload>
          </div>
        }

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <button mat-raised-button color="accent" (click)="close()">{{ 'Close' | translate }}</button>
          @if (!isReadonly) {
            <button mat-raised-button color="primary" (click)="submit()">{{ 'Save' | translate }}</button>
          }
        </div>
      </div>